import React from "react";
import { CSSTransition } from "react-transition-group";
import ClickAway from "../../components/functional/ClickAway";
import slidingMenuStyles from "./SlidingMenu.module.scss"
import animationStyles from "./animationStyles.module.scss";
import classNames from "classnames";

const slideInClassNames = {
    enter: animationStyles['enter'],
    enterActive: animationStyles['enter-active'],
    exit: animationStyles['exit'],
    exitActive: animationStyles['exit-active']
};

export default ({ children, isActive, triggerClass, closeTrigger, additionalClasses }) => {
    return <CSSTransition classNames={slideInClassNames} in={isActive} unmountOnExit timeout={400}>
        <div className={classNames(slidingMenuStyles["sliding-menu"], additionalClasses)}>
            <ClickAway ignoreParentClick={true} listener = {
                () => {
                    closeTrigger();
                }
            }/>
            {children}
        </div>
    </CSSTransition>;
};

